// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa240.stage.monatest.icu/auto-open-api-spec.yaml 1.6.65
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializer used to get fields to update WorkflowAnswerOption.
 * @see #/components/schemas/WorkflowAnswerOptionUserDefined - reference to schema in open-api-spec.yaml
 * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
 * @version 1.6.65
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface WorkflowAnswerOptionUserDefined {
    /**
     * The display text of Workflow-Answer-Option.
     *
     */
    display: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for WorkflowAnswerOptionUserDefined
 */
export namespace WorkflowAnswerOptionUserDefined {
    /**
     * WorkflowAnswerOptionUserDefined Frontend Model with camelCase properties
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * The display text of Workflow-Answer-Option.
         * @type string (`dataFormat` is missing)
         */
        display: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * WorkflowAnswerOptionUserDefined DTO
     * Transforms WorkflowAnswerOptionUserDefined model from/to API object
     * @since 2024-11-26T18:10:41.601818+02:00[Europe/Kiev]
     * @version 1.6.65
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend WorkflowAnswerOptionUserDefined model */
        static toModel(obj: WorkflowAnswerOptionUserDefined): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend WorkflowAnswerOptionUserDefined model */
        static toApi(obj: Model): WorkflowAnswerOptionUserDefined {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as WorkflowAnswerOptionUserDefined;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
